(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/hooks/use-local-storage.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/hooks/use-local-storage.js');
"use strict";


const {
  useCallback,
  useState
} = React;
const useLocalStorage = function (key, domain) {
  let initialValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  let expirationTimeMinutes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  const [storedValue, setStoredValue] = useState(svs.components.Storage.browser.get(key, domain) || initialValue);
  const setValue = useCallback(function (value) {
    let cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    setStoredValue(storedValue => {
      const valueToStore = typeof value === 'function' ? value(storedValue) : value;
      svs.components.Storage.browser.set(key, domain, valueToStore, expirationTimeMinutes, cb);
      return valueToStore;
    });
  }, [key, domain, expirationTimeMinutes]);
  const clearValue = useCallback(() => {
    svs.components.Storage.browser.remove(key, domain);
    setStoredValue(initialValue);
  }, [key, domain, initialValue]);
  return [storedValue, setValue, clearValue];
};
setGlobal('svs.ticketsOrderHome.hooks.useLocalStorage', useLocalStorage);

 })(window);